import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";
import CancellationExperience from "./CancellationExperience";
import CancellationAccommodation from "./CancellationAccommodation";
import CancellationAccommodationEjunifer from "./CancellationAccommodationEjunifer";

const borderColor = "#F5F5F5";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: borderColor,
    borderBottomWidth: 0,
    alignItems: "center",
    //height: 24,
    fontStyle: "bold",
    height: 50,
    fontStyle: "bold",
    overflowY: "scroll",
    justifyContent: "center",
  },
  refrence: {
    width: "25%",
    textAlign: "left",
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    padding:5,
    // paddingLeft: 8,
    // paddingTop: 15,
    // height: 50,
    lineHeight: 1.5,
    
  },
  description: {
    width: "25%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    // paddingLeft: 8,
        padding:5,

    // paddingTop: 15,
    // height: 50,
    lineHeight: 1.5,
  },
  details: {
    width: "30%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    // paddingLeft: 8,
        padding:5,

    // paddingTop: 15,
    lineHeight: 1.5,
    // height: 50,
  },
  service_date: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "left",
    // paddingLeft: 8,
        padding:5,

    // paddingTop: 15,
    // height: 50,
    lineHeight: 1.5,
  },
  //   rate: {
  //     width: '10%',
  //     borderRightColor: borderColor,
  //     borderRightWidth: 1,
  //     textAlign: 'right',
  //     paddingRight: 8,
  //     paddingTop: 15,
  //     height: 40,
  // },
  cancellationpolicy: {
    fontSize: 9,
    lineHeight: 1.5,
  },
});
const InvoiceTableRow = ({ items }) => {
  var items1 = JSON.stringify(items);
  var items2 = JSON.parse(items1);
  var items3 = JSON.parse(items2);

  const rows =
    items3.child != null &&
    items3.child.map((item) => (
      <View>
        <View style={styles.row} key={item.booking_refrence_id}>
          <Text style={styles.refrence}>
            {item.booking_source == 1
              ? item.booking_refrence_id + " - " + item.ReservationLocation
              : item.booking_source == 2
              ? item.booking_refrence_id + " - " + item.hl_booking_id
              : item.booking_refrence_id}
          </Text>
          <Text style={styles.description}>
            {" "}
            {item.rateplan_name
              ? item.rateplan_name
              : + "(" + item.item_name + ")"}
          </Text>
          <Text style={styles.details}>
            {" "}
            {item.rateplan_name}
            {item?.pickup_transfer &&
              `${item.pickup_transfer} to ${item.drop_transfer}`}
          </Text>
          <Text style={styles.service_date}>
            {item.type == "accomodation"
              ? moment(item.booking_checked_in).format("D MMM Y") +
                " - " +
                moment(item.booking_checked_out).format("D MMM Y")
              : moment(item.tour_booking_date).format("D MMM Y")}
          </Text>
          {/* <Text style={styles.rate}>{(item.total.slice(5, 13))}</Text> */}
        </View>
        {item.type != "accomodation"
          ? item?.cancellation_policy != null && (
              <CancellationExperience invoice={item} />
            )
          : item.cancellation_policy_ejunifer != null
          ? item.cancellation_policy_ejunifer != null && (
              <CancellationAccommodationEjunifer invoice={item} />
            )
          : item.cancellation_policy != null && (
              <CancellationAccommodation invoice={item} />
            )}
      </View>
    ));
  return <Fragment>{rows}</Fragment>;
};
export default InvoiceTableRow;
